<div class="payment-result-component-container">

    <section>
        <button mat-button color='accent' routerLink='/'>
          <mat-icon>chevron_left</mat-icon>
          {{ "PAYMENT_RESULT.HOME_LINK" | translate }}
        </button>
    </section>

    <mat-card *ngIf='isPaymentSucceeded' class="branding--section-card">
        <mat-card-content>
            <img src='./assets/images/check_circle_green_96.png' >
            <h2 class='successColour'>{{ "PAYMENT_RESULT.SUCCESS_TITLE" | translate }}</h2>
            <p class='message'>{{ "PAYMENT_RESULT.SUCCESS_MESSAGE" | translate: {orderNum: orderNumber} }}</p>
        </mat-card-content>
    </mat-card>

    <mat-card *ngIf='!isPaymentSucceeded' class="branding--section-card">
        <mat-card-content>
            <img src='./assets/images/stop_sign_alert_red_96.png' >
            <h2 class='errorColour'>{{ "PAYMENT_RESULT.FAIL_TITLE" | translate }}</h2>
            <p class='message'>{{ "PAYMENT_RESULT.FAIL_MESSAGE" | translate }}</p>
            <p>
                <button mat-raised-button color='primary' (click)="tryAgain()">
                  <mat-icon>chevron_left</mat-icon>
                  {{ "PAYMENT_RESULT.TRY_AGAIN_BUTTON" | translate }}
                </button>
            </p>
        </mat-card-content>
    </mat-card>

</div>
